import { Button } from '@chakra-ui/react'

import useAPIWrapper from '@/client/hooks/useAPIWrapper'
import { RPCRefresh } from '@/client/rpc'

export default function SnoozeButton({ sessionId }: { sessionId: number }): React.ReactElement {
  const [handleSnooze, isSnoozing] = useAPIWrapper(
    async () => {
      await RPCRefresh.snoozeFeedback({
        sessionId,
      })
    },
    [sessionId],
    'Snooze Feedback'
  )

  return (
    <Button
      variant="outline"
      width={['100%', 'auto']}
      isLoading={isSnoozing}
      onClick={handleSnooze}
    >
      Answer Tomorrow
    </Button>
  )
}
